// extracted by mini-css-extract-plugin
module.exports = {"video":"Video-module--video--N0Ene","video__player":"Video-module--video__player--2DJZv"};